import React from 'react'
import { connect } from 'react-redux'
import {
  setWidthSliderButtons,
  setPositionX,
  getEndSliderButtons
} from '../../modules/reducer'

import Measure from 'react-measure'

import ButtonsSlider from './ButtonsSlider'

import IconArrow from '../Images/IconArrow'

const WrapperButtonsSlider = ({
  setWidthSliderButtons,
  setPositionX,
  endSliderButtons
}) => {
  return (
    <div className="grid-noGutter">
      <div
        className="col-1"
        style={{
          textAlign: 'center',
          cursor: 'pointer',
          transform: 'rotate(180deg)',
          height: '2em',
          width: '2em'
        }}
        onClick={e => setPositionX(0)}
      >
        <IconArrow size="2em" color="white" />
      </div>
      <Measure
        bounds
        onResize={contentRect => {
          setWidthSliderButtons(contentRect.bounds.width)
        }}
      >
        {({ measureRef }) => (
          <div
            ref={measureRef}
            className="col-10"
            style={{ overflow: 'hidden' }}
          >
            <ButtonsSlider />
          </div>
        )}
      </Measure>
      <div
        className="col-1"
        style={{
          textAlign: 'center',
          cursor: 'pointer',
          height: '2em',
          width: '2em'
        }}
        onClick={e => setPositionX(endSliderButtons)}
      >
        <IconArrow size="2em" color="white" />
      </div>
    </div>
  )
}

const mapStateToProps = ({ reducer }, ownProps) => {
  return {
    endSliderButtons: getEndSliderButtons(reducer)
  }
}

const mapDispatchToProps = { setWidthSliderButtons, setPositionX }

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WrapperButtonsSlider)
